import dayjs from 'dayjs';

export const formatDateWithMiddleDot = (date: string | null | undefined) => {
  if (!date) {
    return '-';
  }
  return dayjs(date).format('DD/MM/YYYY \u2022 HH:mm');
};

export const formatDate = (date: string | null | undefined) => {
  if (!date) {
    return '-';
  }
  return dayjs(date).format('DD/MM/YYYY');
};
